import React from 'react';
import { Link } from 'react-router-dom';
import style from '../../css/CircleBtn.module.css';

function CircleBtn({ data }) {
	return (
		<div className={style.container}>
			{data.map((item) => {
				return (
					<Link className={style.btn} to={item.NaviPage} key={item.id}>
						<img className={style.image} src={item.img} alt="Image" />
						<p className={style.txt}>{item.title}</p>
					</Link>
				);
			})}
		</div>
	);
}

export default CircleBtn;
